import {
    DELEGATE_ALERT,
    DELEGATE_ALERT_SUCCESS,
    DELEGATE_ALERT_FAIL,
    FETCH_DELEGATE_TEAMS,
    FETCH_DELEGATE_TEAMS_SUCCESS,
    FETCH_DELEGATE_TEAMS_FAIL
} from './actionTypes';

export const delegateAlert = ({ alertId, teamIds }) => ({
    type: DELEGATE_ALERT,
    payload: { alertId, teamIds }
});

export const delegateAlertSuccess = response => ({
    type: DELEGATE_ALERT_SUCCESS,
    payload: response
});

export const delegateAlertFail = error => ({
    type: DELEGATE_ALERT_FAIL,
    payload: error
});

export const fetchDelegateTeams = () => ({
    type: FETCH_DELEGATE_TEAMS
});

export const fetchDelegateTeamsSuccess = teams => ({
    type: FETCH_DELEGATE_TEAMS_SUCCESS,
    payload: teams
});

export const fetchDelegateTeamsFail = error => ({
    type: FETCH_DELEGATE_TEAMS_FAIL,
    payload: error
});
